import { get } from "lodash";
import { useTranslate } from "react-admin";

const Title = ({ record }) => {
  const translate = useTranslate();
  return (
    translate(`resources.research-project-evals.name`, {
      smart_count: 1,
    }) +
    " " +
    get(record, "research_project.code")
  );
};
export default Title;
